/* unplugin-vue-components disabled */import script from "./MoblieLoginPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./MoblieLoginPopup.vue?vue&type=script&setup=true&lang=js"

import "./MoblieLoginPopup.vue?vue&type=style&index=0&id=747ed57f&lang=scss"

const __exports__ = script;

export default __exports__